import { render, staticRenderFns } from "./ShopGoodsManage.vue?vue&type=template&id=15197cfb&scoped=true&"
import script from "./ShopGoodsManage.vue?vue&type=script&lang=js&"
export * from "./ShopGoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./ShopGoodsManage.vue?vue&type=style&index=0&id=15197cfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15197cfb",
  null
  
)

export default component.exports